import { render, staticRenderFns } from "./viewReason.vue?vue&type=template&id=62363172&scoped=true"
import script from "./viewReason.vue?vue&type=script&lang=js"
export * from "./viewReason.vue?vue&type=script&lang=js"
import style0 from "./viewReason.vue?vue&type=style&index=0&id=62363172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62363172",
  null
  
)

export default component.exports